import commonActions from '@/store/data/common/actions'
import { webRequestClient } from '@/services'
import { isEmpty, get } from 'lodash'
import helpers from './helpers'
import { errorHandler } from '@/utils/helpers'

const actions = {
    retrieveItems({ commit, rootState, rootGetters }) {
        //check if geographic data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'geography', null)
        if (!dataType) return

        const countryId = rootGetters['account/getAccountCountryId']
        if (countryId === 0) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(countryId, rootState.account)
        return webRequestClient
            .get(_route.route, _route.params)
            .then(geoData => {
                if (get(geoData, 'status') === 'KO') {
                    errorHandler('Error while retrieving geographic data', commit)
                } else if (!isEmpty(geoData.list)) {
                    commit('setRetrievedItems', {
                        items: helpers.parseData(geoData.list, countryId)
                    })
                    commit('setCollection', helpers.instanciateAll(geoData.list, countryId, rootState.account.country.label))
                }
            })
            .catch(error => {
                errorHandler(error, commit)
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...commonActions, ...actions }
